import styled, { css } from "styled-components";

interface ButtonProps {
  size?: string;
}

export const Button = styled.button<ButtonProps>`
  -webkit-appearance: none;
  background: linear-gradient(135deg, #00C8E8 0%, #00BADA 50%, #0088B3 100%);
  border-radius: 12px;
  border: 0;
  color: #ffffff;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-family: 'Outfit', 'Onest', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
  font-size: 14px;
  font-weight: 600;
  letter-spacing: 0.3px;
  line-height: 1;
  outline: none;
  overflow: hidden;
  padding: 12px 24px;
  text-decoration: none;
  transition: all 0.22s cubic-bezier(0.16, 1, 0.3, 1);
  user-select: none;
  white-space: nowrap;
  box-shadow: 0 4px 14px rgba(0, 186, 218, 0.35);

  &:hover {
    transform: translateY(-1px);
    box-shadow: 0 6px 20px rgba(0, 186, 218, 0.5);
    background: linear-gradient(135deg, #0CE0FF 0%, #00C9EA 50%, #0099C6 100%);
  }

  &:active {
    transform: translateY(1px);
    box-shadow: 0 2px 8px rgba(0, 186, 218, 0.3);
  }

  ${(props) => {
    if (props.size) {
      return css`
        width: 100%;
        max-width: 320px;
      `;
    }
  }}
`;
